module.exports = __webpack_public_path__ + "media/images/ui__textCrossLight--dark-22ae6ca3ba06b4fb10230a6e89f3fd10.png";